import NewCRMTable from './NewCRMTable';

export default NewCRMTable;
